import { render, staticRenderFns } from "./ProjectsSingleContent.vue?vue&type=template&id=6f191c94&"
import script from "./ProjectsSingleContent.vue?vue&type=script&lang=js&"
export * from "./ProjectsSingleContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports